import { useTypedFlags } from "./useTypedFlags";
import { useIsGlFirst } from "./useIsGlFirst";

/**
 * Whether the category-to-GL mapping UI is active for the current workspace:
 * the feature flag is on and the workspace is category-first (not GL-first).
 */
export function useIsCategoryGlMappingEnabled(): boolean {
    const { categoryGlMapping } = useTypedFlags();
    const { enabled: isGlFirst } = useIsGlFirst();

    return categoryGlMapping && !isGlFirst;
}
